import { render, staticRenderFns } from "./WaitingAreaEdit.vue?vue&type=template&id=42b0072e&"
import script from "./WaitingAreaEdit.vue?vue&type=script&lang=js&"
export * from "./WaitingAreaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports